// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusContainer_wrapper__9Vh8C"};